<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title *ngIf="isNewStyleGroup==false">{{'collectionById.newStyleGroups.update' | translate}}</h2>
    <h2 mat-dialog-title *ngIf="isNewStyleGroup==true">{{'collectionById.newStyleGroups.create' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button (click)="closeDialog()" mat-icon-button mat-dialog-close aria-label="Close Dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="mat-typography">
    <form [formGroup]="basicDetailsForm" novalidate>
      <div class="form-wrapper">
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'collectionById.newStyleGroups.inputName' | translate}}</label> <span class="required">*</span>
          </div>
          <div class="input-field">
            <input type="text" rows="1" maxlength="121" class="form-control" formControlName="styleGroupName" [readonly]='isPublished'>

            <div *ngIf="f.styleGroupName.invalid && (f.styleGroupName.dirty || f.styleGroupName.touched) && !f.styleGroupName.errors?.whitespace" class="alert alert-danger">
              <div *ngIf="f.styleGroupName.errors?.required">{{'collectionById.newStyleGroups.nameError1' | translate}}</div>
              <div *ngIf="f.styleGroupName.errors?.minlength">{{'collectionById.newStyleGroups.nameError2' | translate}}</div>
              <div *ngIf="f.styleGroupName.errors?.maxlength">{{'collectionById.newStyleGroups.nameError3' | translate}}</div>
              <div *ngIf="f.styleGroupName.errors?.pattern">{{'collectionById.newStyleGroups.nameError4' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'collectionById.newStyleGroups.inputDesc' | translate}}</label>
          </div>
          <div class="input-field">
            <textarea type="text" rows="8" maxlength="481" class="form-control textarea" formControlName="description" [readonly]='isPublished'></textarea>
            <div *ngIf="f.description.invalid && (f.description.dirty || f.description.touched)" class="alert alert-danger">
              <div *ngIf="f.description.errors?.minlength">{{'collectionById.newStyleGroups.descError1' | translate}}</div>
              <div *ngIf="f.description.errors?.maxlength">{{'collectionById.newStyleGroups.descError2' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="" (click)='saveStyleGroupDetails()' mat-raised-button class="btn-primary"
      [disabled]='basicDetailsForm.invalid'>{{'collectionById.newStyleGroups.btnSave' | translate}}</button>
  </mat-dialog-actions>
</div>
